import Http from "@/commons/Http";

/**
 * Camada Business do OCR de matrícula por PDF (Odin) — novo motor assíncrono em lote.
 *
 * Component -> Business -> Http. O processamento em si (união das digitalizações num PDF,
 * despacho ao asgard-ia e batching) fica no backend; aqui só há a leitura de andamento.
 *
 * Diferente do fluxo legado (OCR por página), este motor é assíncrono: o disparo enfileira
 * um único job por ficha e o resultado só fica pronto minutos/horas depois. Por isso a tela
 * precisa consultar o andamento (status) em vez de olhar apenas o contador de fila.
 */
const path = 'api/odin/ocr-pdf';

export default {

  /**
   * Snapshot de andamento do OCR por PDF de uma ficha.
   *
   * @param {string} livro   MATRICULA (indicador real) ou REGISTRO_AUXILIAR.
   * @param {string} fichaId id do indicador real ou do registro auxiliar.
   * @returns Promise com { status, steps: [{ id, nome, status, log }], dataConclusao, mensagemErro }.
   *          status (RAW): NAO_AGENDADO | NA_FILA | RECEIVED | PROCESSING | AWAITING_BATCH | COMPLETED | ERROR.
   */
  async status(livro, fichaId) {
    return Http.get(`${path}/${livro}/${fichaId}/status`);
  },

  /**
   * Dispara o processamento da fila do OCR por PDF na hora ("Executar agora"), em vez de aguardar
   * o job agendado (que só roda em produção). Útil sobretudo em homologação, onde o job não roda.
   */
  async schedulerProcessar() {
    return Http.get('api/odin/ocr/scheduler-processar');
  },

  /**
   * Tira da fila o agendamento de OCR ainda pendente da ficha. Nada foi despachado ao asgard-ia
   * enquanto o job espera, então não há resultado nem crédito a perder: a ficha volta a
   * NAO_AGENDADO e o indicador de progresso se esconde. Recusa se o OCR já tiver despachado.
   */
  async removerDaFila(livro, fichaId) {
    return Http.post(`${path}/${livro}/${fichaId}/remover-da-fila`);
  },
};
